import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import { Image } from 'components/Image/Image';
import { BulletList, Bullet } from 'components/BulletList';

const BoosterEnhancedCashSummaryView = props => {
  return (
    <SectionContainer>
      {props.pixel}
      <FlexContainer className="d-flex-row m-flex-column padL48 m-padL0 items-align-center">
        <CenterAlignBox widthClassName="items-align-center desktopHide">
          <Image imgClass={props.mobileImgClass} />
        </CenterAlignBox>
        <div className="m-format100 m-padLR16 padT16 desktopHide">
          <Label type="H3" typeHeader={'h3'}>
            {' '}
            <span dangerouslySetInnerHTML={{ __html: props.mobileTitle }} />
          </Label>
        </div>
        <FlexContainer className="flex-column format48 m-format100 Body-1 m-items-align-center">
          <div className="H5 padB16 mobileHide">
            <Label typeHeader={'h3'} type="H3">
              {' '}
              <span dangerouslySetInnerHTML={{ __html: props.title }} />{' '}
            </Label>
          </div>

          {props.subtitle && (
            <Label className="padT0 m-padT24 m-padLR16">{props.subtitle}</Label>
          )}

          <BulletList className="padT32 m-padT24 format100 padLR20">
            {props.bullets &&
              props.bullets.length > 0 &&
              props.bullets.map((bullet, index) => (
                <Bullet
                  bulletCharacter={
                    <div
                      className="bgYellow075 pos-rel border-rad50"
                      style={{
                        height: 6,
                        width: 6,
                        top: 10,
                      }}
                    />
                  }
                  className="padB16"
                >
                  <li key={index}> {bullet} </li>
                </Bullet>
              ))}
          </BulletList>
          <div className="m-padLR16 format60 m-format100 padT16">
            <Button
              onClick={props.onClickCTA}
              datatestid="booster-enroll-entry-cta"
              mrphType="primary"
              className=""
              style={{ minWidth: 240 }}
            >
              {props.ctaText}
            </Button>
          </div>
        </FlexContainer>
        <FlexContainer className="format52 flex-row justify-end t-hide padR40">
          <Image imgClass={props.imgClass} />
        </FlexContainer>
      </FlexContainer>
    </SectionContainer>
  );
};

export default BoosterEnhancedCashSummaryView;
